<template>
    <div>
        <el-row style="display: flex;margin-bottom: 10px;">
            <el-col :span="4" v-if="theProjectId == 0">
                <el-select v-model="form.projectId" @change="theProjectAllChange" size="small" filterable clearable
                    placeholder="请选择项目">
                    <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId"
                        :label="item.projectName" :value="item.projectId">
                    </el-option>
                </el-select>
            </el-col>
            <el-col>
                <el-button v-if="addBwCircle"
                    @click="fileWordList = fileImgList = [], ybttrTimes_arr = [{ ybttrTime: '', ybttrId: '' }], $form('addBwCircle')"
                    size='small' type="primary" style="float:right" icon='el-icon-circle-plus'>添加班级论坛
                </el-button>
            </el-col>
        </el-row>
        <div>
            <myform :viewobj='{
                addBwCircleFile: ["新增班级论坛内容", "el-icon-circle-plus"],
                $succeed$: getBwCircleFileList
            }' @confirm='myform2'
                @close="$form('addBwCircleFile', 'reset'); window.sleep(50, v => Myformdata && (fileWordList = [], getBwCircleFileList({ ybcId: theId })))">
                <hide slot='ybcId' />
                <template v-slot:ybcfType="{ Myformdata }">
                    <el-radio-group v-model="Myformdata.ybcfType">
                        <el-radio-button :label="1">图片</el-radio-button>
                        <el-radio-button :label="2">视频</el-radio-button>
                        <el-radio-button :label="3">文件</el-radio-button>
                        <el-radio-button :label="4">其他</el-radio-button>
                    </el-radio-group>
                </template>
                <template v-slot:ybcfPath="{ Myformdata }">
                    <my-upload ref="Imgupload" @fileChange="fileChange($event)" :filearr="fileWordList" :limit="99"
                        @removeAfter="removeAfter($event)" style="margin: 10px 5px 5px;" type="text">
                    </my-upload>
                </template>
            </myform>
            <myform :viewobj='{
                addBwCircle: ["新增班级论坛", "el-icon-circle-plus"],
                updateBwCircle: ["修改班级论坛", "el-icon-edit-outline"],
                $succeed$: getBwCircleList
            }' @confirm='myform'
                @close="$form('addBwCircle', 'reset'); window.sleep(50, v => Myformdata && (fileImgList = []))">
                <hide slot='projectId' />
                <hide slot='ybcId' />
                <template v-slot:ybcCover="{ Myformdata }">
                    <my-upload ref="Imgupload" @fileChange="fileImgChange($event)" :filearr="fileImgList" :limit="99"
                        @removeAfter="removeAfterImg($event)" style="margin: 10px 5px 5px;">
                    </my-upload>
                </template>

            </myform>
            <mytable :tableColums='tableColums_getBwCircleList' api='getBwCircleList'
                xupdateapi='updateOpportunityBusinessCheckImage' :height="H - 165">
                <div slot="ybcCover" slot-scope="{row}" style="max-height:30vh;overflow:auto;max-width:99%;"
                    class="fCenter">
                    <img :src="img" alt="" loading="lazy" v-for="img in (row.ybcCover.split(','))"
                        onclick="document.PreviewVideo(this.src)" :title="'点击预览 ' + img" :key="img" />
                </div>


            </mytable>

            <myform view.lookUsers='论坛内容' id='FormTop' top='20px' @close='$form("lookUsers", "hide")'>
                <div style="height: 40px;display: flex;align-items: center;">
                    <el-col :span="14">
                        <el-select v-model='type' @change="parsch()" size="small" clearable placeholder="请选择附件类型">
                            <el-option label="图片" :value="1"></el-option>
                            <el-option label="视频" :value="2"></el-option>
                            <el-option label="文件" :value="3"></el-option>
                            <el-option label="其他" :value="4"></el-option>
                        </el-select>
                    </el-col>
                    <el-col>
                        <el-button @click="fileWordList = fileImgList = [], $form('addBwCircleFile')" type="primary"
                            size='small' style='margin-left:10px;'>新增附件
                        </el-button>
                    </el-col>
                </div>
                <mytable :tableColums='tableColums_getBwCircleFileList' api='getBwCircleFileList::bwtnId'
                    xupdateapi='updateOpportunityBusinessCheckImage' :height="H - 165">
                    <div slot="ybcfPath" slot-scope="{row}" style="max-height:30vh;overflow:auto;max-width:99%;"
                        class="fCenter">
                        <el-button
                            v-for="(img, index) in (row.ybcfPath && row.ybcfPath != ' ' ? row.ybcfPath.split(',') || [] : [])"
                            :key="index" size="mini" type="text" style="color: deepskyblue;margin: 0 10px;"
                            @click="DocumentLook(img)">
                            文件{{ index + 1 }}</el-button>
                    </div>
                </mytable>
            </myform>
        </div>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
let Base64 = require("js-base64").Base64;
export default {
    data() {
        return {
            type: 1,
            theId: '',
            baseUrl: $Api.baseUrl_online,
            isYbtShow: false,
            tableColums_getBwCircleFileList: {
                $selection: false,
                // oiType: '限制字段key',
                ybcfType: ['附件类型', , '@v-if: 1:图片,2:视频,3:文档,4:其他',],
                ybcfPath: '资源',
                $operation: [
                    '操作', 100,
                    this.deleteBwCircleFile && `@text: 删除#danger
               @click: _confirm('确定要删除吗?')
                       .trigger('deleteBwCircleFile',{ybcfId:$row.ybcfId})
                       .trigger('getBwCircleFileList',{ybcId:$row.ybcId})
              `,
                ],
            },

            ybttrTimes_arr: [{ ybttrTime: "", ybtrrId: '', }],
            fileWordList: [],
            fileImgList: [],
            theProjectId: 0,
            value: '',
            form: {
                projectId: '',
                yasDate: '',
                yasCommand: '',
                yasTimeStart: '',
                yasTimeEnd: '',
                yasDes: '',
            },
            tableColums_getBwCircleList: {
                $selection: false,

                // oiType: '限制字段key',
                ybcTitle: '论坛标题',
                ybcCover: ['图片', 200],
                $operation: [
                    '操作', 180,
                    this.getBwCircleFileList && `@text: 论坛内容上传#success
               @click: @click: $form( 'lookUsers', $this.row = $row ),getBwCircleFileList({ybcId:$row.ybcId},theId = $row.ybcId)
              `,
                    this.updateBwCircle && `@text: 编辑#success
               @click:FormEdit($row)
              `,
                    this.deleteBwCircle && `@text: 删除#danger
               @click: _confirm('确定要删除吗?')
                       .trigger('deleteBwCircle',{ybcId:$row.ybcId})
                       .trigger('getBwCircleList',{projectId:form.projectId})
              `,
                ],
            }
        }
    },
    methods: {
        parsch() {
            this.getBwCircleFileList({
                ybcId: this.theId,
                ybcfType: this.type
            });
        },
        openLoading() {
            //loading请求等待
            this.loading = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        toExportExcelSts: async function () {
            const that = this;
            that.openLoading();
            axios({
                method: 'post',
                url: that.baseUrl + '/opportunity/bw-task-notice/exportIvJobApplicantList',
                data: '',
                withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'token': A.local('$Usertoken'),
                    'projectId': +A.local('$projectId'),
                }
            }).then(function (response) {
                that.loading.close();
                let a = document.createElement('a');
                //ArrayBuffer 转为 Blob
                let blob = new Blob([response.data], { type: "application/vnd.ms-excel" });
                let objectUrl = URL.createObjectURL(blob);
                a.setAttribute("href", objectUrl);
                a.setAttribute("download", '学员提交状态.xlsx');
                a.click();
                that.$message({
                    message: "成功",
                    type: "success"
                });
            }).catch(function (error) {
                that.loading.close();
                console.log(error);
            });
        },
        async getBwCircleFileList_Click(row) {
            this.getBwCircleFileList({ ybtId: row.ybtId }).result(res => {
                if (res.data.data) {
                    this.ybtId = row.ybtId;
                    this.isYbtShow = true;
                }

                // this.getBwCircleFileList_data =res.data.data;
                // this.ybtId = row.ybtId;
                // this.isYbtShow = true;
            })
        },
        FormEdit(row) {
            this.getBwCircleDetails({ ybcId: row.ybcId }).result(res => {
                this.fileImgList = this.fileWordList = [];
                this.Myformdata = JSON.parse(JSON.stringify(res.data.data));
                this.Myformdata.ybcCover = this.Myformdata.ybcCover ? this.Myformdata.ybcCover.split(',') : [];
                if (res.data.data.ybcCover) {
                    if (res.data.data.ybcCover.indexOf(',') != -1) {
                        res.data.data.ybcCover.split(',').forEach((item, index) => {
                            const s = { name: item, url: item };
                            this.fileImgList.push(s);
                        })
                    } else {
                        this.fileImgList = [{ name: res.data.data.ybcCover, url: res.data.data.ybcCover }];
                    }
                }
                this.$form("updateBwCircle", this.Myformdata)
            })

        },
        PreviewVideo2(url) {
            if (url) {
                document.PreviewVideo(url)
            }
        },
        DocumentLook(URL) {
            window.open(`https://filepreview.aojuai.com/onlinePreview?url=${encodeURIComponent(Base64.encode(URL))}`)
        },
        timeDel(index) {
            if (this.ybttrTimes_arr.length == 1) {
                return
            }
            this.ybttrTimes_arr.splice(index, 1)
        },
        timeAdd() {
            const s = { ybttrTime: '', ybtrrId: '', };
            this.ybttrTimes_arr.push(s)
        },
        fileChange(file) {
            console.log(file);
            if (this.Myformdata.ybcfPath.length > 0) {
                this.Myformdata.ybcfPath = this.Myformdata.ybcfPath.concat(file)
            } else {
                this.Myformdata.ybcfPath = file
            }
        },
        fileImgChange(file) {
            console.log(file);
            if (this.Myformdata.ybcCover.length > 0) {
                this.Myformdata.ybcCover = this.Myformdata.ybcCover.concat(file)
                console.log(this.Myformdata.ybcCover);
            } else {
                this.Myformdata.ybcCover = file
            }
        },
        removeAfter(file) {
            const url = this.Myformdata.ybcfPath.findIndex(item => item === file)
            this.Myformdata.ybcfPath.splice(url, 1);
        },
        removeAfterImg(file) {
            const url = this.Myformdata.ybcCover.findIndex(item => item === file)
            this.Myformdata.ybcCover.splice(url, 1);
        },
        async myform(submit, Myformdata) {
            console.log('11');

            this.Myformdata.ybcCover = this.Myformdata.ybcCover ? this.Myformdata.ybcCover.toString() : null;
            this.$nextTick(() => {
            })
            submit();
        },

        async myform2(submit, Myformdata) {
            Myformdata.ybcId = this.theId;
            this.Myformdata.ybcfPath = this.Myformdata.ybcfPath ? this.Myformdata.ybcfPath.toString() : null;
            this.$nextTick(() => {
            })
            submit();
        },

        theProjectAllChange(e) {
            if (e == '') {
                return this.form.projectId = e;
            }
            this.form.projectId = e;
            this.getBwCircleList({ projectId: this.form.projectId })
        },
    },
    created() {
        this.getProjectList({
            pageSize: 0
        });

        this.theProjectId = A.local("$projectId");
        if (this.theProjectId != 0) {
            this.form.projectId = this.theProjectId;
        }
        this.getBwCircleList({ projectId: this.form.projectId })
    },
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/views/Classforum/ClassForumList.vue